import {useState,useEffect} from 'react'
import "./FormComponent.css"
import { v4 as uuidv4 } from 'uuid';//เพิ่ม
const FormComponent=(props)=>{
    const [title,setTitle] = useState('');
    const [amount,setAmount] = useState(0)
    const [formValid,setFormValid] = useState(false);//ep45

    const inputTitle = (event) =>{
        setTitle(event.target.value)
    }
    const inputAmount = (event)=>{
        setAmount(event.target.value)
    }


    const saveItem = (event)=>{
        event.preventDefault();
        const itemData = {
            id:uuidv4(),//เพิ่ม
            title:title,
            amount:Number(amount)
        }
        props.onAddItem(itemData)//เพิ่ม
        setTitle('')
        setAmount(0)
    }
    //ep45 Effect
    useEffect(()=>{
        const check=title.trim().length>0 && amount !==0;
        setFormValid(check)
    },[title,amount])

    return (
        <div>
            <form onSubmit={saveItem}>
                <div className="form-control">
                    <label>ชื่อรายการ</label>
                    <input type="text" placeholder="ระบุชื่อรายการของคุณ"  onChange={inputTitle} value={title}/>
                </div>
                <div className="form-control">
                    <label>จำนวณเงิน</label>
                    <input type="number" placeholder="ระบุจำนวนเงิน" onChange={inputAmount} value={amount}/>
                </div>
                <div>
                    <button type="submit" className="btn" disabled={!formValid}>เพิ่มข้อมูล</button>
                </div>
            </form>
        </div>
    )
}

export default FormComponent;